export default "__VITE_ASSET__CyLyLf0G__"